import { render, staticRenderFns } from "./addWard.vue?vue&type=template&id=d942dbee&scoped=true&"
import script from "./addWard.vue?vue&type=script&lang=js&"
export * from "./addWard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d942dbee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d942dbee')) {
      api.createRecord('d942dbee', component.options)
    } else {
      api.reload('d942dbee', component.options)
    }
    module.hot.accept("./addWard.vue?vue&type=template&id=d942dbee&scoped=true&", function () {
      api.rerender('d942dbee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/WardChildren/addWard.vue"
export default component.exports